import { SearchObject } from "app/common/Model/SearchObject";
import { pagingPatient, pagingStatisticsPatient } from "app/services/PatientService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

class PatientListStatisticsStore {
  pagePatientListStatistics = null
  searchObject = new SearchObject()

  constructor() {
    makeAutoObservable(this);
  }

  pagingPatientListStatistics = async () => {
    let {province,district,commune,national,...orther} = this.searchObject
    if(province) {
      orther.province = province?.id
    }
    if(district) {
      orther.district = district?.id
    }
    if(commune) {
      orther.commune = commune?.id
    }
    if(national) {
      orther.national = national?.id
    }
    try {

      const { data } = await pagingStatisticsPatient({...orther})
      this.pagePatientListStatistics = data
    } catch (error) {
      toast.error("Lấy dữ liệu lỗi!")
    }
  }

  handleChangeFormSearch = (searchObject) => {
    this.searchObject = { ...this.searchObject, ...searchObject };
    this.pagingPatientListStatistics()
  }

  resetStore = () => {
    this.searchObject = new SearchObject();
    this.pagePatientListStatistics = null;
  };
}

export default PatientListStatisticsStore;
